module.exports = __webpack_public_path__ + "static/media/qrEnollmentCode.6bcd0074.svg";